"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OVERLAY_ANNOTATIONS_COLOR = exports.BackgroundLayer = exports.UserSelectionLayer = exports.CommentLayer = exports.OverlayLayer = exports.SelectedElementsLayer = exports.DEFAULT_TEXTURIZE_POLYGON_THRESHOLD = exports.DEFAULT_SKIP_LARGE_POLYGONS_THRESHOLD = exports.ARC_HITBOX_POLYGON_VERTEX_DEGREES = exports.MIN_CIRCLE_RADIUS = exports.MIN_TEXT_THICKNESS = exports.MIN_TEXT_SIZE = exports.MIN_ROUND_RECT_RADIUS = exports.JUNCTION_RADIUS_DEFAULT = exports.PIN_WIDTH_DEFAULT = exports.SEGMENT_MIN_HITBOX_WIDTH = exports.SEGMENT_MIN_WIDTH = exports.TAG_BBOX = exports.TAG_PAD_LABELS = exports.TAG_TEXT_BOUNDS = exports.TAG_POLYGON_FILL = exports.TAG_OVERLAY = exports.TEXTURIZED_ELEMENT_SCALE = exports.WORLD_SCALE = exports.COLOR_UNFILLED = void 0;
exports.COLOR_UNFILLED = 0xffffff;
exports.WORLD_SCALE = 2;
exports.TEXTURIZED_ELEMENT_SCALE = 100;
exports.TAG_OVERLAY = 'overlay';
exports.TAG_POLYGON_FILL = 'polyfill';
exports.TAG_TEXT_BOUNDS = 'text-bounds';
exports.TAG_PAD_LABELS = 'pad-labels';
exports.TAG_BBOX = 'bbox';
exports.SEGMENT_MIN_WIDTH = 0.1;
exports.SEGMENT_MIN_HITBOX_WIDTH = 1;
exports.PIN_WIDTH_DEFAULT = 0.1;
exports.JUNCTION_RADIUS_DEFAULT = 0.5;
exports.MIN_ROUND_RECT_RADIUS = 0;
exports.MIN_TEXT_SIZE = 0.1;
exports.MIN_TEXT_THICKNESS = 1;
exports.MIN_CIRCLE_RADIUS = 0.1 / 2;
exports.ARC_HITBOX_POLYGON_VERTEX_DEGREES = 5;
exports.DEFAULT_SKIP_LARGE_POLYGONS_THRESHOLD = 10000;
exports.DEFAULT_TEXTURIZE_POLYGON_THRESHOLD = Number.POSITIVE_INFINITY;
exports.SelectedElementsLayer = 0xfffd;
exports.OverlayLayer = 0xfffd;
exports.CommentLayer = 0xfffe;
exports.UserSelectionLayer = 0xffff;
exports.BackgroundLayer = 0;
exports.OVERLAY_ANNOTATIONS_COLOR = {
    selected: {
        tint: 0xffffff,
        alpha: 1,
    },
    hover: {
        tint: 0xffffff,
        alpha: 1,
    },
    unselected: {
        tint: 0xffffff,
        alpha: 1,
    },
    selectionNeutral: {
        tint: 0xffffff,
        alpha: 1,
    },
};
//# sourceMappingURL=Constants.js.map